class FullWidthBanner extends HTMLElement {
  constructor() {
    super();
    this.changingTextElement = this.querySelector('.changing-text');

    if (this.changingTextElement) {
      this.texts = this.changingTextElement.dataset.changingText.split(',').map((text) => text.trim());
      this.currentItemIndex = 0;
      this.currentLetterIndex = 0;
      this.typingSpeed = 35; // Faster typing speed (milliseconds per letter)
      this.pauseDuration = 2500; // Slightly longer pause (2.5 seconds)
      this.deletingSpeed = 15; // Fast deleting speed (milliseconds per letter)
    }
  }

  connectedCallback() {
    if (this.changingTextElement) {
      this.typeText();
    }
  }

  disconnectedCallback() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  typeText() {
    const currentItem = this.texts[this.currentItemIndex];

    if (this.currentLetterIndex < currentItem.length) {
      this.changingTextElement.textContent = currentItem.slice(0, this.currentLetterIndex + 1);
      this.currentLetterIndex++;
      this.timeout = setTimeout(() => this.typeText(), this.typingSpeed);
    } else {
      // Item is fully typed, pause before deleting
      this.timeout = setTimeout(() => this.deleteText(), this.pauseDuration);
    }
  }

  deleteText() {
    const currentItem = this.texts[this.currentItemIndex];

    if (this.currentLetterIndex > 0) {
      this.changingTextElement.textContent = currentItem.slice(0, this.currentLetterIndex - 1);
      this.currentLetterIndex--;
      this.timeout = setTimeout(() => this.deleteText(), this.deletingSpeed);
    } else {
      // Item is fully deleted, add a non-breaking space to maintain height
      this.changingTextElement.innerHTML = '&nbsp;';
      // Move to next item
      this.currentItemIndex = (this.currentItemIndex + 1) % this.texts.length;
      this.timeout = setTimeout(() => this.typeText(), this.typingSpeed);
    }
  }
}

customElements.define('full-width-banner', FullWidthBanner);
